import isString from 'lodash/isString';
import moment, { DATE_FORMAT } from '@/utils/moment-wrapper';
import { createTimeSeriesFromDate } from '@/common/time-series-picker/time-series-picker.util';

export const MS_IN_TIME_UNITS = {
    WEEK: 604800000,
    DAY: 86400000,
    HOUR: 3600000,
    MINUTE: 60000,
    SECOND: 1000,
};

export const convertTimeToMs = (time, timeUnit) => {
    if (isNaN(time) || !isString(timeUnit)) return;

    const timeUnitInMs = MS_IN_TIME_UNITS[timeUnit.toUpperCase()];
    if (!timeUnitInMs) return;

    return time * timeUnitInMs;
};

export const convertMsToTime = (timeInMs, timeUnit) => {
    if (isNaN(timeInMs) || !isString(timeUnit)) return;

    const timeUnitInMs = MS_IN_TIME_UNITS[timeUnit.toUpperCase()];
    if (!timeUnitInMs) return;

    return timeInMs / timeUnitInMs;
};

function getPreviousDateRange (first, count) {
    const start = moment(first, { ignoreTimeZone: true });
    const previousEnd = start.clone().subtract(1, 'days');
    const previousStart = previousEnd.clone().subtract(count - 1, 'days');

    return {
        previousStart: previousStart.format(DATE_FORMAT.iso),
        previousEnd: previousEnd.format(DATE_FORMAT.iso),
    };
}

export const getPreviousTimeSeries = ({ spec }) => {
    const { previousStart, previousEnd } = getPreviousDateRange(spec.first, spec.count);

    const timeSeries = createTimeSeriesFromDate({ start: previousStart, end: previousEnd }, true);
    timeSeries.config.type = 'Custom';

    return timeSeries;
};
